import script from "./access_denied.vue?vue&type=script&setup=true&lang=js"
export * from "./access_denied.vue?vue&type=script&setup=true&lang=js"

import "./access_denied.vue?vue&type=style&index=0&id=23204b16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23204b16"]])

export default __exports__